module.exports = "/static/assets/9cc3b64cc7747cc8e7bf59dc8a1614e0.gif";